import React from "react";
import Typography from "@mui/joy/Typography";
import {Stack} from "@mui/joy";

// components
import withNavigate from "../../utils/withNavigate";
import CommonFilterModal from "./CommonFilterModal";
import Chip from "@mui/joy/Chip";
import Pagination from "../Pagination/Pagination";


class CommonPaginatedComponentList extends React.Component{
    render() {
        return (
            <Stack
                spacing={0}
            >
                <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={2}
                    sx={{
                        m: this.props.title||this.props.filterFields?null:0,
                    }}
                >
                    <Typography
                        level="h4"
                    >
                        {this.props.title}
                    </Typography>
                    <Stack
                        direction="row"
                        spacing={2}
                    >
                        {
                            this.props.extraComponents?
                                <>
                                    {
                                        this.props.extraComponents.map((c)=>(
                                            <c.component
                                                {...c.componentProps}
                                                callBack={c.callBack?c.callBack:this.props.callBack}
                                            />
                                        ))
                                    }
                                </>
                                :null
                        }
                        {
                            this.props.filterFields?
                                <CommonFilterModal
                                    key={'CommonFilterModal'+crypto.randomUUID()}
                                    callBack={this.props.filterCallBack}
                                    fields={this.props.filterFields}
                                    value={this.props.filterValue}
                                />:
                                null
                        }
                    </Stack>

                </Stack>
                <Stack
                    spacing={1}
                    sx={{
                        mt: 0,
                        mb: 2
                    }}
                >
                    {this.props.data.map((each) => {
                        let props = {};
                        props[`${this.props.componentKeyword}`] = each
                        props.callBack = this.props.callBack
                        return (
                            <this.props.component
                                key={crypto.randomUUID()}
                                {...this.props.componentProps}
                                {...props}
                            />
                        )
                    })}
                    {
                        this.props.data?.length === 0?
                            <Chip
                                color={'warning'}
                                sx={{mt: 1}}
                            >
                                Список пуст
                            </Chip>:
                            null
                    }
                </Stack>
                {
                    this.props.pages?
                        <Pagination
                            count={this.props.pages}
                            page={this.props.pageNumber}
                            onClick={
                                (value) => {
                                    if (this.props.paginationCallback){
                                        this.props.paginationCallback(value)
                                    }
                                    else{
                                        this.props.navigate(`/${this.props.url}/page/`+value);
                                    }
                                }
                            }
                        />:
                        null
                }
            </Stack>
        )
    }
}

export default withNavigate(CommonPaginatedComponentList)